module.exports = __webpack_public_path__ + "static/media/loader.f0e3c567.svg";